// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spanCursor {
  min-width: 1em;
}

.divitem {
  padding: 0 0 0 15px;
  margin: 0;
}

.iconNode {
  margin-right: 0.5em;
}

.nodeItem {
  margin: 0;
  padding: 0;
  --min-height: 20px;
  cursor: pointer;
}

.selected {
  background-color: var(--ion-color-greenlight);
}`, "",{"version":3,"sources":["webpack://./src/components/general components/tree-node/tree-node.component.scss","webpack://./src/components/general%20components/tree-node/tree-node.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;ACCJ;;ADEA;EACI,mBAAA;EACA,SAAA;ACCJ;;ADEA;EACI,mBAAA;ACCJ;;ADEA;EACI,SAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;ACCJ;;ADEA;EACI,6CAAA;ACCJ","sourcesContent":[".spanCursor {\n    min-width: 1em;\n}   \n\n.divitem {\n    padding: 0 0 0 15px;\n    margin: 0;        \n}\n\n.iconNode {\n    margin-right: 0.5em; \n}\n\n.nodeItem{\n    margin: 0;\n    padding: 0;\n    --min-height: 20px;\n    cursor: pointer;\n}\n\n.selected {    \n    background-color: var(--ion-color-greenlight);    \n}",".spanCursor {\n  min-width: 1em;\n}\n\n.divitem {\n  padding: 0 0 0 15px;\n  margin: 0;\n}\n\n.iconNode {\n  margin-right: 0.5em;\n}\n\n.nodeItem {\n  margin: 0;\n  padding: 0;\n  --min-height: 20px;\n  cursor: pointer;\n}\n\n.selected {\n  background-color: var(--ion-color-greenlight);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
